module.exports = __webpack_public_path__ + "img/v_2.6bad68ff.png";